import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import styles from "./paymentSuccess.module.css";
import WayapayLogo from "../../assets/quickLogo.png";
import { SVGS } from "../../assets/svgs";
import { hasPaymentSuccessFlag } from "../../utils/paymentSuccessLock";

/*
  Terminal page for a successful payment-link payment (replaces the old
  "Payment Successful / You can safely close this tab now" SweetAlert).
  Only reachable via goToPaymentSuccessPage(); see utils/paymentSuccessLock.js
  for how Back/Forward are locked.
*/
export const PaymentSuccess = () => {
  const allowed = hasPaymentSuccessFlag();
  const [closeBlocked, setCloseBlocked] = useState(false);

  useEffect(() => {
    if (!allowed) return undefined;

    const url = window.location.href;
    const pushGuard = () => window.history.pushState({ wqSuccessLock: true }, "", url);

    // Don't stack another guard entry on refresh: history.state survives reloads.
    if (!window.history.state?.wqSuccessLock) pushGuard();

    // Back lands on the entry below the guard; immediately push the guard
    // again so the customer stays here. Forward has nothing to go to.
    window.addEventListener("popstate", pushGuard);
    return () => window.removeEventListener("popstate", pushGuard);
  }, [allowed]);

  if (!allowed) {
    return <Navigate to="/demo?msg=You_cannot_manually_access_this_page." replace />;
  }

  const handleClose = () => {
    // A click is a user gesture, which a few browsers require before honoring
    // window.close(). Most will still refuse for a tab script didn't open.
    try {
      window.close();
    } catch (e) {
      // ignore
    }
    // If the tab actually closed, this never runs.
    setTimeout(() => setCloseBlocked(true), 300);
  };

  return (
    <div className={styles.container}>
      <nav className={styles.navbar}>
        <img src={WayapayLogo} width="150px" alt="WayaQuick logo" />
      </nav>

      <main className={styles.main}>
        <div className={styles.card} role="status" aria-live="polite">
          <div className={styles.icon} aria-hidden="true">
            <svg viewBox="0 0 52 52">
              <circle className={styles.iconCircle} cx="26" cy="26" r="24" fill="none" />
              <path className={styles.iconCheck} fill="none" d="M15 27l7 7 15-15" />
            </svg>
          </div>

          <h1 className={styles.title}>Payment Successful</h1>
          <p className={styles.text}>You can safely close this tab now.</p>

          <button type="button" className={styles.button} onClick={handleClose}>
            Close tab
          </button>

          {closeBlocked && (
            <p className={styles.hint}>
              Your browser didn't let us close this tab. You can close it manually.
            </p>
          )}
        </div>

        <p className={styles.secured}>
          <img src={SVGS.lock_icon} alt="" /> Payment secured by WayaQuick
        </p>
      </main>
    </div>
  );
};
